import * as moment from 'moment';

export const MomentMixin = {
    methods: {
        moment() {
            return moment;
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/MomentMixin.js